module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00074-fs8.5c95d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00074-fs8.png
// module id = 227
// module chunks = 0